<template>
  <div class="time-infos">
    <span> {{ userActivity.created_at }} </span>
  </div>

</template>

<script>
  export default {
    props: {
      userActivity: Object
    }
  };
</script>